import { render } from "./SellerSubCategories.vue?vue&type=template&id=5f6197da&scoped=true"
import script from "./SellerSubCategories.vue?vue&type=script&lang=js"
export * from "./SellerSubCategories.vue?vue&type=script&lang=js"

import "./SellerSubCategories.vue?vue&type=style&index=0&id=5f6197da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f6197da"]])

export default __exports__